import { render } from "./CustomObjectWrapper.vue?vue&type=template&id=66a257b2"
import script from "./CustomObjectWrapper.vue?vue&type=script&lang=js"
export * from "./CustomObjectWrapper.vue?vue&type=script&lang=js"
script.render = render

export default script